export default __webpack_public_path__ + "static/media/tv_video.053994fc.m4v";